import { render, staticRenderFns } from "./emailDetail.vue?vue&type=template&id=ecdfb520&scoped=true"
import script from "./emailDetail.vue?vue&type=script&lang=js"
export * from "./emailDetail.vue?vue&type=script&lang=js"
import style0 from "./emailDetail.vue?vue&type=style&index=0&id=ecdfb520&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdfb520",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ecdfb520')) {
      api.createRecord('ecdfb520', component.options)
    } else {
      api.reload('ecdfb520', component.options)
    }
    module.hot.accept("./emailDetail.vue?vue&type=template&id=ecdfb520&scoped=true", function () {
      api.rerender('ecdfb520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/email/emailDetail.vue"
export default component.exports